//@flow
import i18n from 'i18n';

class I18nHelper {
    preferredLanguage = 'en-US';

    setPreferredLanguage(language: string) {
        this.preferredLanguage = language;
    }

    translate = (
        namespace: string | Array<string>,
        key: string,
        options = {},
        language = this.preferredLanguage
    ): string => {
        return i18n.getFixedT(language, namespace)(key, options);
    };

    getTranslate = (namespace: Array<string>) => {
        return this.translate.bind(null, namespace);
    };

    checkKeyExists(key: string, options = {}) {
        return i18n.exists(key, options);
    }
}

export default new I18nHelper();
